import { Exchange } from "urql";
import { map, pipe } from "wonka";
import { getOverCapacityType, isOverCapacityError } from "./detector";

interface OverCapacityErrorExchangeOptions {
  onOverCapacityError: (errorType: string, error: unknown) => void;
}

/**
 * urql Exchange for handling Over Capacity errors
 * Only processes mutation operations, ignores queries
 */
export function createOverCapacityErrorExchange(
  options: OverCapacityErrorExchangeOptions,
): Exchange {
  return ({ forward }) => {
    return (operations$) => {
      return pipe(
        operations$,
        forward,
        map((result) => {
          // Only handle mutation operations
          if (result.operation.kind !== "mutation") {
            return result;
          }

          // Check if the result has an error
          if (result.error) {
            // Check if it's an Over Capacity error
            if (isOverCapacityError(result.error)) {
              const errorType = getOverCapacityType(result.error);
              if (errorType) {
                // Call the callback with error type and full error
                options.onOverCapacityError(errorType, result.error);
              }
            }
          }

          return result;
        }),
      );
    };
  };
}
